module.exports = __webpack_public_path__ + "static/media/user-dark-green.735d38cf.svg";


//////////////////
// WEBPACK FOOTER
// ./src/resources/icons/user-dark-green.svg
// module id = 1623
// module chunks = 0